import { Component, Input, signal, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationPopupService } from '../../../../../modules/fwcore/services/notification-popup.service';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../../admin/services/admin.service';
import { IsgLoaderComponent } from '../../../../../modules/fwcore/components/isg-loader/isg-loader.component';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-contact-support-page',
  standalone: true,
  imports: [CommonModule, FormsModule, IsgLoaderComponent],
  templateUrl: './contact-support-page.component.html',
  styleUrl: './contact-support-page.component.scss'
})
export class ContactSupportPageComponent {
  isSubmitted!: boolean;

  @Input() model: any = {
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    comments: ''
  };

  @Input() isFallback: boolean = false;

  private formTick = signal(0);

  /** True while the sendFeedback call is in flight. */
  protected isSaving = signal(false);

  canSubmit = computed(() => {
    this.formTick();
    if (!this.isFallback) return true && !!this.model.comments?.trim();
    return !!this.model.firstName?.trim() && !!this.model.company?.trim() && !!this.model.email?.trim() && !!this.model.comments?.trim();
  });

  touchField(): void {
    this.formTick.set(this.formTick() + 1);
  }

  constructor(public activeModal: NgbActiveModal, public service: AdminService, protected notification: NotificationPopupService
  ) { }

  close() {
    this.activeModal.dismiss();
  }

  submit() {
    this.isSubmitted = true;
    if (!this.model.comments || this.model.comments.trim() === '') {
      this.notification.showNotification('Comments is required', 'error');
      return;
    }

    const payload = {
      userName: this.model.firstName ?? '' + ' ' + this.model.lastName ?? '',
      email: this.model.email,
      company: this.model.company,
      comments: this.model.comments
    };

    this.isSaving.set(true);

    this.service.sendFeedback(payload).pipe(
      finalize(() => this.isSaving.set(false))
    ).subscribe({
      next: (res: any) => {
        console.log('Success:', res);
        this.notification.showNotification('Support mail sent succesfully', 'success');
        this.isSubmitted = false;
        this.close();
      },
      error: (err: any) => {
        console.error('Error:', err);
        this.notification.showNotification('Support mail sent failed', 'error');
        this.isSubmitted = false;
      }
    });
  }
}
